import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { GroupService } from './group.service';
import { DemoGroupService } from './demo-group.service';

export function groupServiceFactory(http: HttpClient): GroupService {
  return environment.demoMode
    ? new DemoGroupService(http)
    : new GroupService(http);
}

export const groupServiceProvider = {
  provide: GroupService,
  useFactory: groupServiceFactory,
  deps: [HttpClient]
};